import NotFound from "../components/not-found/NotFound";

const NotFoundPage = () => {
    return ( 
        <div>
            <NotFound />
        </div>
     );
}
 
export default NotFoundPage;